module.exports = __webpack_public_path__ + "static/pathogen-video-67cba997cc0679a30c6e35ae3bd6fe11.png";